import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SheetEventPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.sheetEventRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.sheetEventImport,
    );
    this.sheetEventAutocomplete = permissionChecker.match(
      Permissions.values.sheetEventAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.sheetEventCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.sheetEventEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.sheetEventDestroy,
    );
  }
}
